import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=6a7771bc&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"
import style0 from "./Tour.vue?vue&type=style&index=0&id=6a7771bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7771bc",
  null
  
)

export default component.exports